import { Layouts } from 'react-grid-layout';
import { WidgetItem } from '../../../types';

export const defaultValues = {
  name: '',
  description: '',
  logo: null,
};

/** Default value for teamDashboardItems in localStorage */
export const DEFAULT_TEAM_DASHBOARD_ITEMS: WidgetItem[] = [
  {
    name: "Team's workers",
    type: 'custom',
    system_name: 'team_workers',
    module_name: 'Teams',
    layout: {
      i: 'team_workers',
      x: 0,
      y: 0,
      w: 4,
      h: 8,
      isResizable: true,
      isDraggable: true,
    },
    is_active: true,
    available: true,
  },
  {
    name: "Team's Qualifications",
    system_name: 'teams_qualifications',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/custom/qualifications',
    type: 'custom',
    available: true,
    is_active: true,
    layout: {
      i: 'teams_qualifications',
      h: 8,
      w: 6,
      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Team members gender',
    system_name: 'team_members_gender',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/pie_charts/employees_gender',
    type: 'pie',
    available: true,
    is_active: true,
    layout: {
      i: 'team_members_gender',
      h: 7,

      w: 2,

      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Team members RTW',
    system_name: 'team_members_rtw',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/pie_charts/employees_rtw',
    type: 'pie',
    available: true,
    is_active: true,
    layout: {
      i: 'team_members_rtw',
      h: 7,

      w: 2,

      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Health & Safety',
    system_name: 'team_health_and_safety',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/bar_charts/get_employees_by_survey_tags_stats',
    type: 'bar',
    available: true,
    is_active: true,
    layout: {
      i: 'team_health_and_safety',
      h: 8,

      w: 6,

      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Team members birthdays',
    system_name: 'team_members_birthdays',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/table_charts/employees_birthdays',
    type: 'table',
    available: true,
    is_active: true,
    layout: {
      i: 'team_members_birthdays',
      h: 9,

      w: 6,

      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Team members age',
    system_name: 'team_members_age',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/bar_charts/employees_age',
    type: 'bar',
    available: true,
    is_active: true,
    layout: {
      i: 'team_members_age',
      h: 8,
      w: 6,
      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Team members nationalities',
    system_name: 'team_members_nationalities',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/pie_charts/employees_nationalities',
    type: 'pie',
    available: true,
    is_active: true,
    layout: {
      i: 'team_members_nationalities',
      h: 7,

      w: 2,

      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Team members IDs',
    system_name: 'team_members_ids',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/pie_charts/employees_ids',
    type: 'pie',
    available: true,
    is_active: true,
    layout: {
      i: 'team_members_ids',
      h: 7,

      w: 2,

      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Team members by role',
    system_name: 'team_members_by_role',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/pie_charts/employees_by_role',
    type: 'pie',
    available: true,
    is_active: true,
    layout: {
      i: 'team_members_by_role',
      h: 7,
      w: 2,
      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Number of team members',
    system_name: 'team_members_number',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/number_charts/employees',
    type: 'number',
    available: true,
    is_active: true,
    layout: {
      i: 'team_members_number',
      h: 6,

      w: 2,

      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Recently Registered',
    system_name: 'recent_registered_employees',
    module_name: 'Teams',
    url: 'dashboards/widgets/teams/companies/{company_id}/table_charts/recent_registered_employees',
    type: 'table',
    available: true,
    is_active: true,
    layout: {
      i: 'recent_registered_employees',
      h: 9,
      w: 6,
      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
  {
    name: 'Team Proximity',
    system_name: 'proximity_to_work',
    module_name: 'Teams',
    type: 'custom',
    available: true,
    is_active: true,
    layout: {
      i: 'proximity_to_work',
      h: 8,
      w: 6,
      x: 0,
      y: 0,
      isDraggable: true,
      isResizable: true,
    },
  },
];

export const widgets = DEFAULT_TEAM_DASHBOARD_ITEMS;

/**
 * Отбрасывает из сохранённого конфига виджеты, которых больше нет в дефолтах
 * (напр. удалённые CSCS/EUSR/CPCS). Если конфиг не передан — берёт дефолты.
 */
export const sanitizeTeamDashboard = (
  items?: WidgetItem[] | null,
  layouts?: Layouts | null
): { items: WidgetItem[]; layouts: Layouts } => {
  const validNames = new Set(DEFAULT_TEAM_DASHBOARD_ITEMS.map(w => w.system_name));
  const cleanItems = (items ?? DEFAULT_TEAM_DASHBOARD_ITEMS).filter(w => validNames.has(w.system_name));
  const sourceLayouts = layouts ?? DEFAULT_TEAM_DASHBOARD_LAYOUTS;
  const cleanLayouts = Object.fromEntries(
    Object.entries(sourceLayouts).map(([bp, arr]) => [bp, arr.filter(l => validNames.has(l.i))])
  ) as Layouts;
  return { items: cleanItems, layouts: cleanLayouts };
};

/** Default value for teamDashboardLayouts in localStorage */
export const DEFAULT_TEAM_DASHBOARD_LAYOUTS: Layouts = {
  lg: [
    {
      w: 6,
      h: 7,
      x: 0,
      y: 24,
      i: 'team_workers',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 6,
      h: 8,
      x: 0,
      y: 8,
      i: 'teams_qualifications',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 6,
      y: 14,
      i: 'team_members_gender',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 6,
      y: 21,
      i: 'team_members_rtw',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 6,
      h: 8,
      x: 0,
      y: 16,
      i: 'team_health_and_safety',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 6,
      h: 9,
      x: 0,
      y: 31,
      i: 'team_members_birthdays',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 6,
      h: 8,
      x: 0,
      y: 40,
      i: 'team_members_age',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 6,
      y: 7,
      i: 'team_members_nationalities',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 6,
      y: 42,
      i: 'team_members_ids',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 6,
      y: 0,
      i: 'team_members_by_role',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 5,
      x: 6,
      y: 49,
      i: 'team_members_number',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 6,
      h: 9,
      x: 0,
      y: 48,
      i: 'recent_registered_employees',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 6,
      h: 8,
      x: 0,
      y: 0,
      i: 'proximity_to_work',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
  ],
  md: [
    {
      w: 4,
      h: 8,
      x: 0,
      y: 8,
      i: 'team_workers',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 4,
      h: 8,
      x: 0,
      y: 16,
      i: 'teams_qualifications',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 0,
      y: 24,
      i: 'team_members_gender',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 2,
      y: 24,
      i: 'team_members_rtw',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 4,
      h: 8,
      x: 0,
      y: 31,
      i: 'team_health_and_safety',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 4,
      h: 9,
      x: 0,
      y: 39,
      i: 'team_members_birthdays',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 4,
      h: 8,
      x: 0,
      y: 48,
      i: 'team_members_age',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 0,
      y: 56,
      i: 'team_members_nationalities',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 2,
      y: 63,
      i: 'team_members_ids',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 0,
      y: 70,
      i: 'team_members_by_role',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 7,
      x: 2,
      y: 70,
      i: 'team_members_number',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 4,
      h: 9,
      x: 0,
      y: 77,
      i: 'recent_registered_employees',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 4,
      h: 8,
      x: 0,
      y: 0,
      i: 'proximity_to_work',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
  ],
  sm: [
    {
      w: 2,
      h: 8,
      x: 0,
      y: 16,
      i: 'team_workers',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 8,
      x: 0,
      y: 8,
      i: 'teams_qualifications',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 24,
      i: 'team_members_gender',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 1,
      y: 24,
      i: 'team_members_rtw',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 8,
      x: 0,
      y: 31,
      i: 'team_health_and_safety',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 9,
      x: 0,
      y: 39,
      i: 'team_members_birthdays',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 8,
      x: 0,
      y: 48,
      i: 'team_members_age',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 56,
      i: 'team_members_nationalities',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 1,
      y: 63,
      i: 'team_members_ids',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 70,
      i: 'team_members_by_role',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 5,
      x: 0,
      y: 77,
      i: 'team_members_number',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 9,
      x: 0,
      y: 82,
      i: 'recent_registered_employees',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 2,
      h: 8,
      x: 0,
      y: 0,
      i: 'proximity_to_work',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
  ],
  xs: [
    {
      w: 1,
      h: 8,
      x: 0,
      y: 0,
      i: 'team_workers',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 8,
      x: 0,
      y: 8,
      i: 'teams_qualifications',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 16,
      i: 'team_members_gender',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 23,
      i: 'team_members_rtw',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 8,
      x: 0,
      y: 30,
      i: 'team_health_and_safety',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 9,
      x: 0,
      y: 38,
      i: 'team_members_birthdays',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 8,
      x: 0,
      y: 47,
      i: 'team_members_age',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 55,
      i: 'team_members_nationalities',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 76,
      i: 'team_members_ids',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 83,
      i: 'team_members_by_role',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 5,
      x: 0,
      y: 90,
      i: 'team_members_number',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 9,
      x: 0,
      y: 95,
      i: 'recent_registered_employees',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 8,
      x: 0,
      y: 104,
      i: 'proximity_to_work',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
  ],
  xxs: [
    {
      w: 1,
      h: 8,
      x: 0,
      y: 0,
      i: 'team_workers',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 8,
      x: 0,
      y: 8,
      i: 'teams_qualifications',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 16,
      i: 'team_members_gender',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 23,
      i: 'team_members_rtw',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 8,
      x: 0,
      y: 30,
      i: 'team_health_and_safety',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 9,
      x: 0,
      y: 38,
      i: 'team_members_birthdays',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 8,
      x: 0,
      y: 47,
      i: 'team_members_age',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 55,
      i: 'team_members_nationalities',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 76,
      i: 'team_members_ids',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 7,
      x: 0,
      y: 83,
      i: 'team_members_by_role',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 5,
      x: 0,
      y: 90,
      i: 'team_members_number',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 9,
      x: 0,
      y: 95,
      i: 'recent_registered_employees',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
    {
      w: 1,
      h: 8,
      x: 0,
      y: 104,
      i: 'proximity_to_work',
      moved: false,
      static: false,
      isDraggable: true,
      isResizable: true,
    },
  ],
};
